module.exports = __webpack_public_path__ + "static/media/pleading-face-svgrepo-com.3bcc7731.svg";